exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-77f8ffcf]{font-size:1rem;border:none;border-right:1px solid #e8e8e8;vertical-align:middle;padding:1.25rem}td[data-v-77f8ffcf]:last-child{border-right:none}tr.ticket-row[data-v-77f8ffcf]{border-bottom:1px solid #e8e8e8!important}tr.open[data-v-77f8ffcf]{-webkit-box-shadow:inset 4px 0 0 #6fa551;box-shadow:inset 4px 0 0 #6fa551}tr.closed[data-v-77f8ffcf]{-webkit-box-shadow:inset 4px 0 0 crimson;box-shadow:inset 4px 0 0 crimson}tr.waiting-list[data-v-77f8ffcf]{-webkit-box-shadow:inset 4px 0 0 #ecb618;box-shadow:inset 4px 0 0 #ecb618}tr.table-active[data-v-77f8ffcf]{background-color:#e7f3ff!important}.badge-lg[data-v-77f8ffcf]{font-size:.95rem;padding:.4rem .7rem;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77f8ffcf","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Assets/components/RegistrationCategories/Tickets/Table/BulkRow.vue
// module id = 2498
// module chunks = 1